/**
 * Helper to build CSV content.
 *  
 */

/**
 * The separator to use in the csv content
 */
export const CSV_SEPARATOR: string = ';';


export class CsvBuilder {

    private _data: string = '';
  
    get data(): string { return this._data; }


  
    public addValue(value: any) {
      this._data += value + CSV_SEPARATOR;
    }
  
    public newLine() {
      this._data += '\n';
    }
  }